(function () {
  if (window.LumineWishlist) return;

  var STORAGE_KEY = 'lumine_wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* localStorage unavailable (private mode, etc). Fail silently. */
    }
    window.dispatchEvent(new CustomEvent('lumine:wishlist:change', { detail: { handles: handles } }));
  }

  var api = {
    all: function () {
      return read();
    },
    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },
    add: function (handle) {
      var handles = read();
      if (handles.indexOf(handle) === -1) {
        handles.push(handle);
        write(handles);
      }
    },
    remove: function (handle) {
      var handles = read().filter(function (h) {
        return h !== handle;
      });
      write(handles);
    },
    toggle: function (handle) {
      if (api.has(handle)) {
        api.remove(handle);
      } else {
        api.add(handle);
      }
    },
    count: function () {
      return read().length;
    }
  };

  window.LumineWishlist = api;

  if (window.customElements && !customElements.get('favorite-button')) {
    class FavoriteButton extends HTMLElement {
      connectedCallback() {
        this.handle = this.getAttribute('data-handle');
        this.button = this.querySelector('button');
        if (!this.button || !this.handle) return;
        this.refresh();
        this._onClick = this.onClick.bind(this);
        this._onChange = this.refresh.bind(this);
        this.button.addEventListener('click', this._onClick);
        window.addEventListener('lumine:wishlist:change', this._onChange);
      }

      disconnectedCallback() {
        if (this._onChange) window.removeEventListener('lumine:wishlist:change', this._onChange);
      }

      onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        window.LumineWishlist.toggle(this.handle);
      }

      refresh() {
        var active = window.LumineWishlist.has(this.handle);
        this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
        this.button.setAttribute('aria-label', active ? 'Remove from favorites' : 'Add to favorites');
      }
    }
    customElements.define('favorite-button', FavoriteButton);
  }

  function updateHeaderBubble() {
    var bubble = document.querySelector('[data-wishlist-count]');
    if (!bubble) return;
    var count = api.count();
    bubble.textContent = count;
    bubble.hidden = count === 0;
  }

  updateHeaderBubble();
  window.addEventListener('lumine:wishlist:change', updateHeaderBubble);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderBubble);
  }
})();
